import React from 'react';
import UploadDisabledModal from './UploadDisabledModal';

interface UploadButtonProps {
  openFileDialog: () => void;
  isUploading?: boolean;
  error?: string | null;
  clearError?: () => void;
  showDisabledModal?: boolean;
  setShowDisabledModal?: (v: boolean) => void;
  className?: string;
}

const UploadButton: React.FC<UploadButtonProps> = ({
  openFileDialog,
  isUploading = false,
  error = null,
  clearError,
  showDisabledModal = false,
  setShowDisabledModal,
  className = ''
}) => {
  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={openFileDialog}
        className={`upload-button ${className}`}
        aria-label="Upload new session"
        disabled={isUploading}
      >
        {isUploading ? 'Uploading...' : 'Upload Session'}
      </button>

      <UploadDisabledModal
        isOpen={showDisabledModal || !!error}
        onClose={() => {
          setShowDisabledModal?.(false);
          clearError?.();
        }}
        message={error || undefined}
      />
    </div>
  );
};

export default UploadButton;
